<template>
  <div>
    <canvas id="bar-chart-month-intent" height="400"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js/auto";

export default {
  name: "BarChartMonthIntent",
  props: {
    data: {
      type: Array,
      require: true,
    },
    yAxisTitle: {
      type: String,
      require: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        parsing: {
          xAxisKey: "name",
          yAxisKey: "percent",
        },
        layout: {
          padding: 0,
        },
        scales: {
          y: {
            ticks: {
              beginAtZero: true,
            },
            title: {
              display: true,
              align: "center",
              text: "จำนวนการเข้าถึง(%)",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
          x: {
            beginAtZero: true,
            title: {
              display: true,
              align: "center",
              text: "อินเทนต์",
              color: "#242424",
              font: {
                family: "Kanit-Regular",
                size: 12,
                lineHeight: 2,
              },
              padding: { top: 0, left: 0, right: 0, bottom: 10 },
            },
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            bodyAlign: "center",
            yAlign: "bottom",
            titleColor: "#575757",
            backgroundColor: "#F1F1F1",
            titleMarginBottom: 0,
            padding: 12,
            callbacks: {
              title: function(context) {
                const contextElement = context[0];
                const index = contextElement.dataIndex;
                const label = "จำนวนการเข้าถึง";
                const value = contextElement.dataset.data[index]
                const percent = value.percentFormat
                const count = value.count
                return `${label} ${percent} (${count}คน)`
              },
              label: function(context) {
                return;
              },
              afterLabel: function(context) {
                return;
              },
            },
          },
        },
      },
    };
  },
  mounted() {
    const ctx = document
      .getElementById("bar-chart-month-intent")
      .getContext("2d");
    new Chart(ctx, {
      type: "bar",
      data: {
        datasets: [
          {
            barPercentage: 0.4,
            backgroundColor: "#7160C4",
            data: this.data,
            borderRadius: {
              bottomLeft: 0,
              bottomRight: 0,
              topLeft: 5,
              topRight: 5,
            },
          },
        ],
      },
      options: this.options,
    });
  },
};
</script>
<style lang="scss" scoped></style>
